export const ModalEnum = {
  'TEST_EXPIRED': 'TEST_EXPIRED',
  'CANCEL_PLAN': 'CANCEL_PLAN',
  'UPGRADE_PLAN': 'UPGRADE_PLAN',
  'DOWNGRADE_PLAN': 'DOWNGRADE_PLAN'
}
